import React from 'react';

const HelpContents = (props) => {
  switch (props.lang) {
  case 'fi':
    return (
      <div>
        <h2>Useiden kohteiden metatiedon muokkaaminen kerralla</h2>
        <p>Tämän toiminnon avulla voit muokata useiden kohteiden metatietoa kerralla.</p>
        <p>Huomaa, että tässä toiminnossa et näe mitä metatietoja yksittäisellä kohteella on!
        Tämän toiminnon käyttöä ei siis ole suositeltavaa yksittäisen kohteen metatietojen muokkaukselle. 
        Muokataksesi yksittäisen kohteen metatietoja, avaa kohde katselunäkymään ja valitse sieltä 
        'muokkaa metatietoja'-toiminto.</p>
        <h3>Valinnainen arvojen lähettäminen</h3>
        <p>Kenttien edellä olevat ruksit tarkoittavat että näin valittujen kenttien arvot 
        lähetetään palvelimelle tallennusnappia painaessa. Tämä toiminto mahdollistaa tyhjien arvojen 
        lähettämisen palvelimelle, jolloin muokkaustemplaattia voi käyttää myös kentän tyhjentämiseen.</p>
        <h3>Useita arvoja mahdollisesti sisältävät kentät</h3>
        <p>
        Kentissä, jotka voivat sisältää useita arvoja, voi Lisää-valinnan valitsemalla lisätä arvon entisten rinnalle. 
        </p>
        <h3>Yhden arvon sisältävät tekstikentät</h3>
        <p>
        Tekstikentissä, joissa vain yksi arvo on mahdollinen, Lisää-valinta
        mahdollistaa syötetyn tekstin lisäämisen kentässä jo olevan tekstin perään. Uusi teksti erotetaan välilyönnillä vanhasta sisällöstä.
        </p>
      </div>
    );
    
  case 'en':
    return (
      <div>
        <h2>Editing metadata of multiple objects at once</h2>
        <p>Use this fuction to edit metadata of multiple objects at once.</p>
        <p>Note that in this function you will not see what metadata is set for a single item!
        Therefore, the use of this function is not recommended for the editing of metadata for a single item.
        To customize metadata for a single item, open the item in the viewport and select from there
        'Edit metadata' function.</p>
        <h3>Optional sending of values</h3>
        <p>The marks above the fields indicate that the values of the fields thus selected
        is sent to the server by pressing the record button. This function allows empty values
        to be sent to the server, so the editing template can also be used to clear the field.</p>
        <h3>Single-value text fields</h3>
        <p>
        In text fields where only one value is possible, the Add option
        allows you to add the text you entered after the text already in the field. The new text is separated wuth a space from the old content.
        </p>
      </div>
    );

  case 'sv':
    return (
      <div>
        <h2>Redigering metadata för flera objekt samtidigt</h2>
        <p>Med den här funktionen kan du redigera metadata för flera objekt samtidigt.</p>
        <p>Observera att i den här funktionen kan du inte se vad metadata är för ett enda objekt!
            Därför rekommenderas inte användningen av denna funktion för redigering av metadata för ett enda objekt.
            För att redigera metadata för ett enda objekt, öppna objektet i visningsporten och välj därifrån
            "redigera metadata" -funktionen.</p>
        <h3>Valfri sändning av värden</h3>
        <p>Kryss framför fälten betyder att värdena för de fält som är valda
            skickas till servern genom att trycka på sparningsknappen. Den här funktionen tillåter tomma värden
            att skicka till servern, så redigeringsmallen kan också användas för att rensa fältet.</p>
        <h3>Fält som kan innehålla flera värden</h3>
        I fälten som kan innehålla flera värden kan du välja 'Lägg till' för att lägga till värdet dessutom till de föregående värdena.
        <h3>Textfält med ett värde</h3>
        I textfält där endast ett värde är möjligt, kan du lägga till texten efter texten som finns
        redan i fältet med 'Lägg till' val. Den nya texten är åtskild av ett mellanslag från det gamla innehållet.
      </div>
    );
  }

  return <p>Error</p>;
};

export default HelpContents;